/* eslint-disable @angular-eslint/prefer-inject */
import { RequisitionLineDataService } from '../infrastructure/requisition-lines/requisition-line.data.service';
import {
    RequisitionLineCreate,
    RequisitionLineDto,
    RequisitionLineRead,
    RequisitionLineSearchParams,
} from '../entities/requisition-line.dto';
import { RequisitionLineStore } from '../infrastructure/requisition-lines/requisition-line.store';
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { RequisitionLineMapper } from '../infrastructure/requisition-lines/requisition-line.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IManageEntityRoutes } from '@pf/shared-common';

@Injectable()
export class RequisitionLineFacade extends AbstractManageEntityFacade<
    RequisitionLineDto,
    RequisitionLineRead,
    RequisitionLineCreate,
    RequisitionLineSearchParams
> {
    nameField: keyof RequisitionLineDto = 'lineNumber';

    constructor(
        dataService: RequisitionLineDataService,
        store: RequisitionLineStore,
        mapper: RequisitionLineMapper
    ) {
        super(
            dataService,
            null as unknown as IManageEntityRoutes,
            store,
            mapper
        );
    }

    override getParentId(dto: RequisitionLineDto) {
        return dto.requisition?.id as string;
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof RequisitionLineDto, string>> {
        return { lineNumber: searchText };
    }
}
